module.exports = __webpack_public_path__ + "media/images/version_merge/banks/maestro_logo-2a742930b5bb385bf850b2f1edc0876d.png";